import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const DeclinedMessageActions = createActionGroup({
	source: 'DeclinedMessage',
	events: {
		'Add Declined Message': props<{ message: string }>(),
		'Add Declined Code And Message': props<{ code: string; message: string }>(),
		'Reset Declined Message': emptyProps(),
	},
});
